import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-tour-additional-intro-modal',
  templateUrl: './tour-additional-intro-modal.component.html',
  styleUrls: ['./tour-additional-intro-modal.component.scss']
})
export class TourAdditionalIntroModalComponent {

  constructor(@Inject(MAT_DIALOG_DATA) private _params) { }

  get params() {
    return this._params;
  }
}
